import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { GetEventImagesDTO, GetEventsDTO } from '../../dto/events'
import { store } from '../../store'

export const getEventImages = async ( id: number, reported: boolean, page: number = 1 ) => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/events/${ id }/images?reported=${ reported ? "true" : "false" }&page=${ page }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_IMAGES_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_EVENT_IMAGES_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_EVENT_IMAGES_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetEventImagesDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_IMAGES_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_EVENT_IMAGES_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_EVENT_IMAGES_OK', eventImageGroups: body.eventImageGroups, reported: reported, pagination: body.pagination } )

}
